var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{'btn-disabled': _vm.disabled, 'btn-big': _vm.big, 'layout-gom': _vm.layoutGom},on:{"click":function($event){return _vm.handleClick()}}},[(!_vm.text)?_c('img',{class:{'btn-big-img': _vm.big, 'black': _vm.black},attrs:{"src":_vm.icon}}):_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec11d59a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CircleButton.vue
// module id = null
// module chunks = 